import * as R from 'ramda';

export const getDossierId = R.prop('dossierId');
export const toDossierIds = R.map(getDossierId);

export const MAX_COMMENT_LENGTH = 255;
